/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable remeda/prefer-remeda-typecheck */
import axios from 'axios'
import { useCallback, useState } from 'react'
import { setCookie } from 'react-use-cookie'
import type { Status } from '@velasca/types'
import { getVelascaApiUrl } from '@velasca/utils/get-velasca-api-url'
import { $settings } from '@velasca/utils/globals'

const velascaApiUrl = getVelascaApiUrl(process.env.NODE_ENV)

/**
 * TODO: SHOP-4760.
 *
 * Every vendor call is deferred through the `velascaConsent` registry (same
 * policy as the function-effect newsletter popup): captured at submit time,
 * delivered at grant, never without consent. Vendor `typeof` checks live
 * inside the callbacks so they run at fire time, after the gated loaders.
 */
const newsletterAddTracking = (email: string) => {
  setCookie('newsletter', 'accepted', {
    days: 365,
  })
  // Vendor globals are read inside the deferred callbacks (fire time), so
  // only the registry is bound here.
  // eslint-disable-next-line prefer-destructuring
  const velascaConsent = window.velascaConsent

  // No consent registry, no tracking (consent-manager.liquid renders it
  // before any bundle runs).
  if (!velascaConsent) {
    return
  }

  velascaConsent.onPurpose(
    'marketing',
    'newsletter Lead (fbq)',
    () => {
      typeof window.fbq !== 'undefined' && window.fbq('track', 'Lead')
    },
    { event: true },
  )
  velascaConsent.onPurpose(
    'marketing',
    'newsletter iscrizione (_tfa)',
    () => {
      typeof window._tfa !== 'undefined' &&
        window._tfa.push({
          notify: 'event',
          name: 'iscrizionenewsletter',
        })
    },
    { event: true },
  )
  // Generic gtag hit (no send_to): either grant opens the gate — destinations
  // are only configured under their own granted purpose.
  velascaConsent.onAnyPurpose(
    ['measurement', 'marketing'],
    'newsletter generate_lead (gtag)',
    () => {
      typeof window.gtag !== 'undefined' &&
        window.gtag('event', 'generate_lead')
    },
    { event: true },
  )
  velascaConsent.onPurpose(
    'marketing',
    'newsletter identify (klaviyo)',
    () => {
      typeof window.klaviyo !== 'undefined' &&
        $settings.klaviyo_enabled &&
        window.klaviyo.identify({ $email: email })
    },
    { event: true },
  )
}

interface NewsletterAddData {
  success: boolean
}

const newsletterAdd = (email: string) => {
  return axios.post<NewsletterAddData>(`${velascaApiUrl}/newsletter/add`, {
    email,
  })
}

interface NewsletterState {
  status: Status
  setStatus: (status: NewsletterState['status']) => void
  subscribe: (email: string) => void
}

export const useNewsletter = (): NewsletterState => {
  const [status, setStatus] = useState<Status>('idle')

  const subscribe = useCallback(
    (email: string) => {
      setStatus('loading')

      newsletterAdd(email)
        .then(() => {
          setStatus('success')
          newsletterAddTracking(email)
        })
        .catch(() => {
          setStatus('error')
        })
    },
    [setStatus],
  )

  return {
    status,
    setStatus,
    subscribe,
  }
}
